import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("DocumentContentGetOutput")
export class DocumentContentGetOutput {
    @JsonProperty()
    public content: string = JsonPropertyEmpty;
}
